module.exports = __webpack_public_path__ + "img/腾讯_01.d60a0dbe.jpg";